export const categories = [
  {
    slug: "dingyi-jiedu",
    name: "定义解读",
    description: "深入解析援助交配的概念界定、术语演变与学术定义框架",
    icon: "ri-book-read-line",
    color: "accent",
    articleCount: 8,
  },
  {
    slug: "shehui-beijing",
    name: "社会背景",
    description: "探讨援助交配现象产生的社会结构、文化土壤与历史脉络",
    icon: "ri-global-line",
    color: "primary",
    articleCount: 10,
  },
  {
    slug: "xinli-fenxi",
    name: "心理分析",
    description: "从心理学视角剖析参与者行为动机、心理机制与情感需求",
    icon: "ri-psychotherapy-line",
    color: "secondary",
    articleCount: 7,
  },
  {
    slug: "shehui-yingxiang",
    name: "社会影响",
    description: "分析援助交配对个体、家庭及社会整体的多维影响与连锁反应",
    icon: "ri-pulse-line",
    color: "accent",
    articleCount: 9,
  },
  {
    slug: "anli-yanjiu",
    name: "案例研究",
    description: "基于真实案例的深度剖析，呈现现象背后的复杂性与多元面向",
    icon: "ri-file-search-line",
    color: "primary",
    articleCount: 6,
  },
];

export const categoryMap: Record<string, (typeof categories)[number]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});